import {transportCategories, TransportCategory} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Tabs} from "@mantine/core";
import {getTransportCategoryColorRefByType} from "../../../util/transport-category-ui-util";

export type TransportCategoryTabProps = {
  category: TransportCategory
};

export const TransportCategoryTab = (props: TransportCategoryTabProps) => {
  const {category} = props;

  const {t} = useTranslation(["translation", "common"]);

  return (
    <Tabs.Tab
      color={getTransportCategoryColorRefByType(category)}
      value={category.code}>
      {t(category.displayValue.id, {ns: "common"})}
    </Tabs.Tab>
  );
};

export type TransportCategoryTabsProps = {
  // props here
};

export const TransportCategoryTabs = (props: TransportCategoryTabsProps) => {
  return (
    <Tabs.List>
      {transportCategories.map((category) => (
        <TransportCategoryTab key={category.code} category={category}/>
      ))}
    </Tabs.List>
  );
};
